import { MP_FN } from 'features/dpoh-dashboards/constants';

export const mpEntityConfig = {
    entityType: 'MPs',
    entityFormattedTitle: 'MPs',
    entityCataloguePath: `/institutions/103/dpoh?institution=${encodeURIComponent(
        'House of Commons'
    )}&title=${encodeURIComponent(MP_FN)}`,
    entityCatalogueConfig: {
        constants: {
            ttmLimit: 0,
        },
    },
    entityDashboardConfig: {
        constants: {
            socialMediaExhibitDefaultRows: 5,
        },
        isSavePDFEnabled: false,
    },
};
